import React, { PureComponent } from 'react';
import { get as lodashGet } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import appDux from 'src/redux/app/';
import constants from 'src/constants';
import ElementStyleEditor from './ElementStyleEditor';

const MAX_MATERIAL_ID = constants.labels;
const orderElementStylesByMaterialId = (a, b) =>
  lodashGet(a, 'materialId', MAX_MATERIAL_ID) -
  lodashGet(b, 'materialId', MAX_MATERIAL_ID);

const mapStateToProps = (state) => ({
  uniqueSelectedElementStyles: appDux.selectors.getUniqueSelectedElementStyles(
    state,
  ),
});

export class SelectedElements extends PureComponent {
  static propTypes = {
    uniqueSelectedElementStyles: PropTypes.object.isRequired,
  };

  render() {
    return (
      <div>
        {Object.values(this.props.uniqueSelectedElementStyles)
          .sort(orderElementStylesByMaterialId)
          .map((uniqueStyle) => (
            <ElementStyleEditor style={uniqueStyle} />
          ))}
      </div>
    );
  }
}

export default connect(mapStateToProps)(SelectedElements);
